<script>
import { MdsButton } from "@mds/button";
import MdsForm from "@mds/form";
import MdsSelect from "@mds/select";
import MdsFieldset from "@mds/fieldset";
import AdlRangeSlider from "../range-slider/RangeSlider.vue";
import MdsLoader from "@mds/loader";

import AdlDataList from "../DataList/DataList.vue";
import MdsSwitch from "@mds/switch";
import AdlMonthPicker from "../MonthPicker/MonthPicker.vue";

export default {
  name: "AdlEloquaForm",
  props: {
    data: {
      type: Object,
      required: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: "medium",
    },
  },
  data() {
    return {
      form: Object.assign({}, this.data),
      listdata: [],
    };
  },
  components: {
    MdsButton,
    MdsForm,
    MdsSelect,
    MdsFieldset,
    MdsLoader,
    AdlRangeSlider,
    MdsSwitch,
    AdlDataList,
    AdlMonthPicker,
  },
  methods: {
    inputChange() {
      this.$emit("formChange", this.form);
    },
    dropDownChange(callBackMethod, selectedValue, options) {
      if (callBackMethod) {
        let selectedObj = options.filter((sr) => sr.value == selectedValue);
        this.$emit("dropDownChange", callBackMethod, selectedObj[0]);
      } else {
        this.$emit("formChange", this.form);
      }
    },
    EditDetails(data) {
      this.$emit("OnEdit", data);
    },
    refreshValue() {
      this.$emit("refresh");
    },
    onReset() {
      this.$emit("reset", this.form);
    },
    onSubmit() {
      const errors = {};

      if (errors.size) {
        this.$emit("error", errors);
      } else {
        this.$emit("submit", this.form);
      }
    },
    submitForm(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 13) {
        this.onSubmit();
      }
    },
    getFormErrors() {
      const errors = new Map();
      this.form.elements.forEach((element) => {
        if (element.errors.length) {
          errors.set(element.id, element.errors);
        }
      });

      return errors;
    },
  },
};
</script>

<template>
  <div :class="[$style['mca-components-ui__eloqua-form']]">
    <div>
      <mds-form
        :size="size"
        autocomplete="on"
        :name="data.name"
        @submit.prevent.native=""
      >
        <mds-fieldset :disabled="loading" hidden-legend>
          <div
            v-for="format in form.groupFormat"
            :class="[$style['cfSet'], $style[format.class]]"
          >
            <div v-if="format.name" :class="$style['group-title']">
              {{ format.name }}
            </div>
            <template v-for="groupElement in format.element">
              <adl-range-slider
                :data-id="form.elements[groupElement].id"
                v-if="form.elements[groupElement].displayType === 'slider'"
                :size="size"
                :options="form.elements[groupElement].options"
                :lower-label="form.elements[groupElement].name"
                :name="form.elements[groupElement].htmlName"
                :step="form.elements[groupElement].step"
                :isShowRefreshIcon="
                  form.elements[groupElement].isShowRefreshIcon
                "
                v-model="form.elements[groupElement].value"
                :key="form.elements[groupElement].id"
                :required="form.elements[groupElement].isRequired"
                :min="form.elements[groupElement].minValue"
                :max="form.elements[groupElement].maxValue"
                :inputMax="form.elements[groupElement].inputMax"
                :isShowDecimal="form.elements[groupElement].isShowDecimal"
                :inputFormat="form.elements[groupElement].inputFormat"
                :isCurrencyFormat="form.elements[groupElement].isCurrencyFormat"
                :tooltipMessage="form.elements[groupElement].tooltipMessage"
                :refreshText="form.elements[groupElement].refreshText"
                :disabled="form.elements[groupElement].isdisabled"
                :maxlength="form.elements[groupElement].maxlength"
                @change="inputChange()"
                @refresh="refreshValue"
              ></adl-range-slider>

              <mds-select
                :data-id="form.elements[groupElement].id"
                v-else-if="
                  form.elements[groupElement].displayType === 'singleSelect'
                "
                :size="size"
                :options="form.elements[groupElement].options"
                :label="form.elements[groupElement].name"
                :name="form.elements[groupElement].htmlName"
                v-model="form.elements[groupElement].value"
                @change="
                  dropDownChange(
                    form.elements[groupElement].emitevent,
                    form.elements[groupElement].value,
                    form.elements[groupElement].options
                  )
                "
                :key="form.elements[groupElement].id"
                :required="form.elements[groupElement].isRequired"
              ></mds-select>

              <adl-data-list
                v-else-if="
                  form.elements[groupElement].displayType ===
                    'AdditionalInformation' &&
                  form.elements[groupElement].options != null &&
                  form.elements[groupElement].options.length > 0
                "
                :headingtext="form.elements[groupElement].name"
                :listdata="form.elements[groupElement].options"
                :editbuttonvisible="true"
                @OnEdit="EditDetails"
              >
              </adl-data-list>
              <mds-switch
                :class="$style['mdsswitch']"
                v-else-if="form.elements[groupElement].displayType === 'switch'"
                :data-id="form.elements[groupElement].id"
                :name="form.elements[groupElement].htmlName"
                :size="size"
                v-model="form.elements[groupElement].value"
                @change="inputChange()"
                :key="form.elements[groupElement].id"
                >{{ form.elements[groupElement].label }}</mds-switch
              >

              <adl-month-picker
                v-else-if="
                  form.elements[groupElement].displayType === 'monthPicker'
                "
                :typing="true"
                :label="form.elements[groupElement].label"
                :data-id="form.elements[groupElement].id"
                :name="form.elements[groupElement].htmlName"
                :size="size"
                :yearTerm="form.elements[groupElement].yearTerm"
                :minYear="form.elements[groupElement].minYear"
                v-model="form.elements[groupElement].value"
                @input="inputChange()"
                >{{ form.elements[groupElement].label }}</adl-month-picker
              >

              <mds-button
                :data-id="form.elements[groupElement].id"
                v-else-if="form.elements[groupElement].displayType === 'submit'"
                :size="size"
                :name="form.elements[groupElement].htmlName"
                variation="primary"
                :type="form.elements[groupElement].htmlName"
                :key="form.elements[groupElement].id"
                style="margin-right: 10px; margin-top: 24px"
                :disabled="form.elements[groupElement].isdisabled"
                @click="onSubmit"
                >{{ form.elements[groupElement].name }}</mds-button
              >
              <mds-button
                :data-id="form.elements[groupElement].id"
                v-else-if="form.elements[groupElement].displayType === 'reset'"
                :size="size"
                :name="form.elements[groupElement].htmlName"
                variation="secondary"
                :type="form.elements[groupElement].htmlName"
                :key="form.elements[groupElement].id"
                style="margin-right: 10px; margin-top: 24px"
                :disabled="form.elements[groupElement].isdisabled"
                @click="onReset()"
                >{{ form.elements[groupElement].name }}</mds-button
              >
              <span
                v-else-if="form.elements[groupElement].displayType === 'link'"
                :class="$style['my-link']"
                @click="$emit('linkClick', form.elements[groupElement].method)"
                href="#"
                >{{ form.elements[groupElement].name }}</span
              >
            </template>
          </div>
        </mds-fieldset>
      </mds-form>
    </div>

    <div :class="$style.loader" v-if="loading">
      <mds-loader aria-label="Submitting form ..."></mds-loader>
      <h6>Submitting form</h6>
    </div>
  </div>
</template>

<style module lang="scss">
@import "@mds/constants";
@import "@mds/typography";
@import "@mds/link";
.mca-components-ui__eloqua-form {
  .cfSet {
    width: 100%;
    float: left;
  }
  .mdsswitch {
    margin-top: 10px;
  }
  .group-section {
    border-top: $mds-border-separator-on-light;
    padding-top: $mds-space-2-x;
    margin-top: $mds-space-2-x;
  }
  .group-title {
    @include mds-eyebrow-heading();
    font-size: $mds-space-inset-s !important;
    margin-bottom: $mds-space-1-x;
  }
  .my-link {
    @include mds-link();
    color: $mds-interactive-color-primary-default !important;
    float: right;
    margin-top: 30px;
    font-size: 14px;
    line-height: 16px;
    border-bottom: 1px solid $mds-interactive-color-primary-default;
    cursor: pointer;
  }
  .mds-range-slider .mds-range-slider__input {
    flex: 0 0 50%;
  }
  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: hsla(0, 100%, 0%, 0.2);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    h6 {
      @include mds-eyebrow-heading;
    }
  }

  .mds-form--medium-layout {
    .mds-label {
      margin-bottom: $mds-space-2-x;
    }

    .mds-range-slider {
      margin-bottom: $mds-space-2-x;
      &:last-child {
        margin-bottom: 0px;
      }
      .mds-label {
        margin-bottom: 0px !important;
      }
    }
  }
}
</style>
